import * as React from 'react'
import type { CSSProperties } from 'react'

import { cn } from '@/lib/utils'

/**
 * Skeleton loading primitive.
 *
 * Renders a shimmering placeholder for content that is loading.
 */

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>

export function Skeleton({ className, style, ...props }: SkeletonProps) {
  return (
    <div
      style={{ ...styles.skeleton, ...style }}
      className={cn('skeleton', className)}
      {...props}
    />
  )
}

/**
 * Skeleton text line.
 */
export function SkeletonLine({ className, style, ...props }: SkeletonProps) {
  return (
    <Skeleton
      style={{ height: '16px', width: '100%', ...style }}
      className={className}
      {...props}
    />
  )
}

const styles: Record<string, CSSProperties> = {
  skeleton: {
    borderRadius: 'var(--radius-sm)',
    // Animation is handled via the .skeleton class in global.css
  },
}
